import { ScrollTop } from 'primereact/scrolltop';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { SubmitProjectProposalSumUp } from 'features/SubmitProjectProposal/pages';
import TimeLine from 'features/ReviseProjectProposal/components/TimeLine';

function SubmitProjectProposalSumUpPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <TimeLine />
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            border: '1px solid var(--surface-border)',
            backgroundColor: 'white',
            borderRadius: '12px',
          }}
        >
          <SubmitProjectProposalSumUp />
          <ScrollTop target="parent" />
        </div>
      </Layout>
    </LayoutProvider>
  );
}

export default SubmitProjectProposalSumUpPage;
